import React from "react";
import PropTypes from "prop-types";
import {Input as InputReactstrap} from "reactstrap";

export default function Input(props) {
  const [value, setValue] = React.useState(props.value);
  const onChange = (e) => setValue(e.target.value);
  const onBlur = () => {
    props.onChange(value);
    props.onBlur && props.onBlur();
  };

  React.useEffect(() => setValue(props.value), [props.value]);

  return <InputReactstrap
    {...props}
    onChange={onChange}
    onBlur={onBlur}
    value={value}
  />

};

Input.defaultProps = {
  type: 'text',
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};
